import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { adminLogin } from '@/lib/api';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Inserisci email e password');
      return;
    }

    setIsLoading(true);
    try {
      const response = await adminLogin(email, password);
      localStorage.setItem('admin_token', response.token);
      localStorage.setItem('admin_email', response.email);
      localStorage.setItem('admin_role', response.role || 'admin');
      
      // Logistics goes directly to resi page
      if (response.role === 'logistics') {
        navigate('/admindea26/resi');
      } else {
        navigate('/admindea26/dashboard');
      }
    } catch (error) {
      toast.error('Credenziali non valide');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-6">
      <motion.div 
        className="max-w-md w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="text-center mb-12">
          <div className="w-16 h-16 mx-auto bg-white text-black flex items-center justify-center mb-6">
            <Lock className="w-7 h-7" />
          </div>
          <h1 className="font-heading text-3xl text-white font-normal tracking-tight mb-2">
            Area Admin
          </h1>
          <p className="text-zinc-400 font-light">
            Gestione Resi e Cambi
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="text-xs font-bold tracking-[0.15em] uppercase text-zinc-500 mb-3 block">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-0 border-b border-zinc-700 px-0 py-3 text-white placeholder:text-zinc-600 focus:outline-none focus:border-white transition-colors"
              placeholder="email@dominio.com"
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="text-xs font-bold tracking-[0.15em] uppercase text-zinc-500 mb-3 block">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-0 border-b border-zinc-700 px-0 py-3 text-white placeholder:text-zinc-600 focus:outline-none focus:border-white transition-colors"
              placeholder="••••••••"
              data-testid="admin-password-input"
            />
          </div>

          <Button 
            type="submit"
            disabled={isLoading}
            className="w-full bg-white text-black hover:bg-zinc-200 rounded-none h-12 uppercase tracking-[0.2em] text-xs font-bold mt-8"
            data-testid="admin-login-btn"
          >
            {isLoading ? 'Accesso in corso...' : (
              <span className="flex items-center justify-center gap-3">
                Accedi
                <ArrowRight className="w-4 h-4" />
              </span>
            )}
          </Button>
        </form>

        <p className="text-center mt-8">
          <a href="/" className="text-xs text-zinc-500 hover:text-white transition-colors">
            Torna al portale clienti
          </a>
        </p>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
